import script from "./UrlModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UrlModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__